import React from 'react'
import Jumbotron from '../layout/Jumbotron'

const src = require('../../assets/images/2938171.jpg')
const src3 = require('../../assets/images/2938186.jpg')

function getSuburbsLine (suburbs, count = 3, join = 'and') {
  let subs = suburbs.slice(0, count)
  let line
  if (subs.length === 0) return ''
  else if (subs.length === 1) line = subs[0].name
  else {
    const last = subs[subs.length - 1]
    line = subs.map(s => s.name).slice(0, -1).join(', ') + ` ${join} ${last.name}`
  }
  return line
}

function SuburbJumbotron ({ suburb, clinic, ...props }) {

  let suburbsLine = ''
  if (suburb.nearbySuburbs) suburbsLine = ` in ${getSuburbsLine(suburb.nearbySuburbs, 4, 'or')}`
  let streetLine = (clinic && clinic.address) ? ` on ${clinic.address.split(',')[0]}` : ''

  const lead = `Book an appointment at our ${suburb.name} physio clinic${streetLine}.<br/>Our ${suburb.name} physiotherapy clinic services patients needing a physio${suburbsLine}.`

  return (
    <Jumbotron
      title={`We're your physiotherapist <br/>in ${suburb.name}`}
      lead={lead}
      image={src}
      imageMobile={src3}
      {...props}
    />
  )
}

export default SuburbJumbotron
